import { render, staticRenderFns } from "./PlatformsPage.vue?vue&type=template&id=5311dc6b&scoped=true"
import script from "./PlatformsPage.vue?vue&type=script&lang=js"
export * from "./PlatformsPage.vue?vue&type=script&lang=js"
import style0 from "./PlatformsPage.vue?vue&type=style&index=0&id=5311dc6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5311dc6b",
  null
  
)

export default component.exports